import { Pagination } from '@/@types';
import configuration from '@/configuration';

export const gql = String.raw;

export const getGraphlClient = ({ token, locale }: { token?: string; locale?: string }) => {
  const url = new URL(configuration.server?.graphql || configuration.graphql);
  if (locale) {
    url.searchParams.set('locale', locale);
  }

  return async <T = any>({ query, variables }: { query: ReturnType<typeof gql>; variables?: any }): Promise<{ data: T; errors?: any[] }> => {
    return fetch(url.toString(), {
      method: 'post',
      body: JSON.stringify({ query, variables }),
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(configuration.server?.apikey && { 'x-api-key': configuration.server?.apikey }),
      },
    }).then((x) => {
      if (!x.ok) {
        console.log('ERROR', x.statusText);
      }
      return x.json();
    });
  };
};

export const paginationToArray = <T extends any>(pagination?: null | Pagination<T>): T[] => {
  if (!pagination) {
    return [];
  }
  return pagination.edges.map((x) => {
    return x.node;
  });
};
